export default __webpack_public_path__ + "static/media/elipses-horizontal.41566efa.svg";